module.exports = __webpack_public_path__ + "svg/SourceSansPro-Black.svg?12553c8d6b7d6352317d7abe8f0d2b12";